import { makeStyles } from "tss-react/mui";

import { createVersionCodeTag, hasApkMetadata } from "@dashboard/files/utils";
import { Tag } from "@dashboard/shared/components/Tag/Tag";
import { createRolloutTag, getTagReactKey, sortTags } from "@dashboard/shared/tags";
import { MinimalTableCell, TruncatedText } from "@shared/table/MinimalTableComponents";

const useStyles = makeStyles()((theme) => ({
    tagsBox: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
}));

/**
 * The file's name with all of its tags wrapped underneath, as on the files page, so no tag is ever hidden behind a
 * scrollbar.
 */
export const FileNameCell = ({ file }: { file: API.File }) => {
    const { classes } = useStyles();

    const title = hasApkMetadata(file) ? file.metadata?.file?.apk?.manifest?.package : file.filename;
    const removableTags = sortTags(file.metadata?.user?.tags ?? []);
    const generatedTags = sortTags(
        [createVersionCodeTag(file), createRolloutTag(file.rolloutPercentage)].filter((tag) => tag !== null),
    );

    return (
        <MinimalTableCell fluid fluidMinWidth="20ch">
            <TruncatedText title={title || "-"} />
            {removableTags.length || generatedTags.length ? (
                <div className={classes.tagsBox}>
                    {removableTags.map((item) => (
                        <Tag key={getTagReactKey(item)} item={item} />
                    ))}
                    {generatedTags.map((item) => (
                        <Tag key={getTagReactKey(item)} item={item} generated />
                    ))}
                </div>
            ) : null}
        </MinimalTableCell>
    );
};
